<template>
  <div :class="['banner', {'mobile-banner': disMobile}]">
    <v-carousel
      cycle
      hide-delimiters
      show-arrows-on-hover
      :items-per-page="itemsPerPage"
      v-model="carousel"
      :height="carouselHeight"
      
    >
      <v-carousel-item
        v-for="(item, i) in items"
        :key="i"
        :src="item.banner_image"
      >
      </v-carousel-item>
    </v-carousel>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  data() {
    return {
      disMobile: false,
      itemsPerPage: 1,
      carousel: 0,
      carouselHeight: "auto",
    };
  },

  computed: {
    ...mapGetters("bannerStore", ["items"]),
    ...mapGetters("grobal", ["mobileDevice"]),
  },

  created() {
    window.addEventListener("resize", this.myEventHandlerResizeScreen);
    this.myEventHandlerResizeScreen(); // Call once to set initial state
  },

  methods: {
    ...mapActions("bannerStore", ["BannerTes"]),
    myEventHandlerResizeScreen() {
      const width = window.innerWidth;

      if (width < 600) {
        this.itemsPerPage = 1;
        this.carouselHeight = "150px";
      } else if (width < 960) {
        this.itemsPerPage = 2;
        this.carouselHeight = "300px";
      } else {
        this.itemsPerPage = 3;
        this.carouselHeight = "auto";
      }
    },
    prev() {
      if (this.carousel > 0) this.carousel--;
    },
    next() {
      if (this.carousel < this.items.length - 1) this.carousel++;
    },
  },

  async mounted() {
    await this.BannerTes();
  },

  destroyed() {
    window.removeEventListener("resize", this.myEventHandlerResizeScreen);
  },
};
</script>

<style scoped>
.banner {
  width: 100%;
  transition: height 0.3s ease;
}
</style>
